export const classes = {
  wrapper:
    'flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 cursor-pointer hover:bg-black/5 dark:hover:bg-white/5',
  staticWrapper: 'flex items-center px-2.5 py-1.5',
  label: 'select-none text-sm font-bold text-taupe-3 dark:text-mauve-1',
  aiMark:
    'text-[0.5rem] font-semibold text-brand-accent dark:text-brand-accent-dark',
  caretIcon: 'text-base text-taupe-2 dark:text-mauve-2',
};
